declare global {
  interface Window {
    dataLayer: any[];
  }
}

export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return;

  window.addEventListener('message', (event) => {
    const config = useRuntimeConfig();
    const trustedOrigin = config.public.chatIframeDomain;

    if (
      event.origin === trustedOrigin &&
      event.data?.type === 'datalayer-push' &&
      event.data?.event
    ) {
     window.dataLayer = window.dataLayer || [];
     window.dataLayer.push(event.data.event);
    }
  });
});
